"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjValueByDotProp = void 0;
exports.getObjValueByDotProp = function (obj, property) {
    var value = property.split('.').reduce(function (o, i) { return o && o[i]; }, obj);
    return value !== undefined ? value : value;
};
